import actionsMassive from './actions-massive.json'
import alert from './alert.json'
import blocklist from './blocklist.json'
import catalog from './catalog.json'
import costSimulator from './cost-simulator.json'
import editing from './editing.json'
import error from './error.json'
import exporting from './exporting.json'
import fulfillment from './fulfillment.json'
import general from './general.json'
import importing from './importing.json'
import improveScore from './improve-score.json'
import menu from './menu.json'
import multivariation from './multivariation.json'
import notices from './notices.json'
import productNew from './product-new.json'
import productPerformance from './product-performance.json'
import product from './product.json'
import promotional from './promotional.json'
import status from './status.json'
import steps from './steps.json'
import timeline from './timeline.json'
import tour from './tour.json'

export default {
  general,
  menu,
  product,
  catalog,
  fulfillment,
  actionsMassive,
  costSimulator,
  multivariation,
  productNew,
  productPerformance,
  ...alert,
  ...blocklist,
  ...notices,
  ...editing,
  ...error,
  ...exporting,
  ...importing,
  ...menu,
  ...promotional,
  ...status,
  ...steps,
  ...timeline,
  ...tour,
  ...improveScore,
}
